import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconFilterOutline = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block w-full h-full fill-current"
    >
      <path
        d="M1 2a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V15l-4 4v-6.586a1 1 0 00-.293-.707L1.293 5.293A1 1 0 011 4.586V2z"
        stroke="#A0AEC0"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>,
  );
IconFilterOutline.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconFilterOutline;
